/**
 * Admin home component fetch all post from database and displays also filter and delete posts
 */
 import { css } from '@emotion/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { GridLoader } from 'react-spinners';
import { bindActionCreators } from 'redux';
import { DialogBox } from '../../../common/dialogbox';
import { utilPostService } from '../../../common/utils';
import * as postsActions from '../../../store/admin';
 
 const override = css`
   position: fixed;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
 `;
 
 class Posts extends React.Component {
   constructor(props) {
     super(props);
     this.redirectToaddConnection = this.redirectToaddConnection.bind(this);
     this.onTypesChange = this.onTypesChange.bind(this);
     this.onCategoryChange = this.onCategoryChange.bind(this);
     this.onInputChange = this.onInputChange.bind(this);
     this.onReset = this.onReset.bind(this);
     this.actionsButtonFormatter = this.actionsButtonFormatter.bind(this);
     this.onLiveNowChange = this.onLiveNowChange.bind(this);
     this.onMadePublicChange = this.onMadePublicChange.bind(this);
     this.onFilter = this.onFilter.bind(this);

    // Calculate dates for last 90 days
    const today = new Date();
    const ninetyDaysBack = new Date(today);
    const ninetyDaysAhead = new Date(today);
    ninetyDaysBack.setDate(today.getDate() - 90);
    ninetyDaysAhead.setDate(today.getDate() + 365);


     this.state = {
       modal_data: {
         show: false,
       },
       filterData: {
         types: [],
         categories: [],
publish_start: ninetyDaysBack, // 90 days ago
        publish_end: ninetyDaysAhead,
       },
       isLoading: false,
       isReseting: false,
       isFitering: false,
       isDeleating: false,
       errors: {},
     };
   }
 
  getCurrentDate() {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }

  getDate90DaysBack() {
    const today = new Date();
    const ninetyDaysBack = new Date(today.setDate(today.getDate() - 90));
    return ninetyDaysBack.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }

    getDate90DaysAhead() {
    const today = new Date();
    const ninetyDaysAhead = new Date(today.setDate(today.getDate() + 365));
    return ninetyDaysAhead.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }
   /**
    * It is a react lifycycle method which is invoked immediately after a component is mounted
    */
   componentDidMount() {

     this.props.fetchCategories({
       token: this.props.token,
       params: '?category_type=All',
     });
 
     // get posts signed url
 
    //  this.props.getPostsSignedUrl({
    //    token: this.props.token,
    //    params: '',
    //  });
    this.props.fetchPosts({
        token: this.props.token,
        params: `?get_posts_for_admin=true&publish_start=${this.getDate90DaysBack()}&publish_end=${this.getDate90DaysAhead()}&published=false`,
    });
   }
   /**
    * It is a react lifycycle method which is invoked immediately after updating occurs.
    * @param {*} prevProps : Getting previous props
    * @param {*} prevState : Getting previous state
    */
   componentDidUpdate(prevProps, prevState) {
     if (prevProps.postActionLoading && !this.props.postActionLoading) {
       if (!_.isEqual(prevProps.signed_url, this.props.signed_url)) {
         if (this.props.signed_url) {
           this.props.fetchPostsBySignedUrl({
             url: this.props.signed_url,
           });
         }
       }
 
       if (prevState.isDeleating) {
         this.setState(
           {
             isLoading: false,
             isDeleating: false,
           },
           function () {
             NotificationManager.success(
               'Success message',
               'Deleted successfully.'
             );
           }
         );
       }
 
       if (prevState.isReseting) {
         this.setState({
           isLoading: false,
           isReseting: false,
         });
       }
 
       if (prevState.isFitering) {
         this.setState({
           isLoading: false,
           isFitering: false,
         });
       }
     }
   }
    
    
   handleDateChange(date, name) {
     let fields = this.state.filterData;
     fields[name] = date;
     this.setState({
       fields,
     });
   }
 
   onDeletePost(cell, row, rowIndex) {
     if (row.postUid) {
       this.setState({
         ...this.state,
         modal_data: {
           ...this.state.modal_data,
           show: true,
           data: {
             heading: 'Delete Post',
             body: 'Are you sure you want to permanetly remove this post ?',
             rowId: row.postUid,
           },
         },
       });
     }
   }
   OnDialogSubmit(id) {
     this.setState(
       {
         ...this.state,
         modal_data: {
           ...this.state.modal_data,
           show: false,
         },
         isLoading: true,
         isDeleating: true,
       },
       function () {
         this.props.deletePost({
           id: id,
           token: this.props.token,
         });
       }
     );
   }
 
   onEditPost(cell, row, rowIndex) {
     if (row.type === 'newsletter') {
       // this.props.history.push()
       this.props.onEditPostButton('/admin/edit-newsletter/' + row.postUid);
     } else {
       // this.props.history.push('/admin/edit-notice/' + row.postUid)
       this.props.onEditPostButton('/admin/edit-notice/' + row.postUid);
     }
   }
 
   onTypesChange(e) {
     let fields = this.state.filterData;
     if (e.target.checked) {
       fields['types'].push(e.target.value);
       this.setState({
         fields,
       });
     } else {
       if (_.includes(fields.types, e.target.value)) {
         _.remove(fields.types, function (o) {
           return o === e.target.value;
         });
         this.setState({
           fields,
         });
       }
     }
   }
 
   onLiveNowChange(e) {
     let fields = this.state.filterData;
     if (e.target.checked) {
       fields['published'] = true;
     } else {
       fields['published'] = false;
     }
     this.setState({
       fields,
     });
   }
 
   onMadePublicChange(e) {
     let fields = this.state.filterData;
     if (e.target.checked) {
       fields['made_public'] = true;
     } else {
       fields['made_public'] = false;
     }
     this.setState({
       fields,
     });
   }
 
   onInputChange(e) {
     const { name, value } = e.target;
     let fields = this.state.filterData;
     fields[name] = value;
     this.setState({
       fields,
     });
   }
 
   onCategoryChange(e) {
     let fields = this.state.filterData;
     if (e.target.checked) {
       let gobj = _.find(this.props.categories, {
         categoryname: e.target.value,
       });
       if (gobj) {
         fields['categories'].push(gobj.categoryname);
         this.setState({
           fields,
         });
       }
     } else {
       if (_.includes(fields.categories, e.target.value)) {
         _.remove(fields.categories, function (o) {
           return o === e.target.value;
         });
         this.setState({
           fields,
         });
       }
     }
   }
 
   actionsButtonFormatter(cell, row, enumObject, rowIndex) {
     return (
       <div className="d-flex align-items-center nav-con">
         <button
           type="button"
           className="bg-dark filter-btn width-btn"
           onClick={() => this.onEditPost(cell, row, rowIndex)}
         >
           <i className="fa fa-pencil" aria-hidden="true"></i>
         </button>
         <button
           type="button"
           className="bg-primary filter-btn width-btn"
           onClick={() => this.onDeletePost(cell, row, rowIndex)}
         >
           <i className="fa fa-trash" aria-hidden="true"></i>
         </button>
       </div>
     );
   }
 
   redirectToaddConnection(e) {
     e.preventDefault();
     this.props.history.push('/admin/add-newsletter');
   }
 
   handleCloseModal() {
     this.setState({
       ...this.state,
       modal_data: {
         ...this.state.modal_data,
         show: false,
       },
     });
   }
 
   validateForm() {
     let fields = this.state.filterData;
     let errors = {};
     let formIsValid = true;
 
     if (fields['publish_start'] && !fields['publish_end']) {
       formIsValid = false;
       errors['publish_end'] = '*Please select publish end date.';
     }
 
     if (fields['publish_end'] && !fields['publish_start']) {
       formIsValid = false;
       errors['publish_start'] = '*Please select publish start date.';
     }
 
     if (fields['publish_end'] < fields['publish_start']) {
       formIsValid = false;
       errors['publish_end'] = '*Please select valid date.';
     }
     this.setState({
       errors: errors,
     });
     return formIsValid;
   }
 
   onFilter(e) {
     e.preventDefault();
     if (this.validateForm()) {
       let fields = this.state.filterData;
       let params = '?get_posts_for_admin=' + true + '&published=' + false;
 
       if (fields['publish_start']) {
         if (params !== '?') {
           params = params + '&';
         }
         params =
           params +
           `publish_start=${moment(fields['publish_start']).format(
             'YYYY-MM-DD'
           )}&publish_end=${moment(fields['publish_end']).format('YYYY-MM-DD')}`;
       }
       if (fields['types'] && fields['types'].length > 0) {
         if (params !== '?') {
           params = params + '&';
         }
         params = params + `types=${fields['types'].join()}`;
       }
       if (fields['categories'] && fields['categories'].length > 0) {
         if (params !== '?') {
           params = params + '&';
         }
         params = params + `categories=${fields['categories'].join()}`;
       }
       if (fields['title']) {
         if (params !== '?') {
           params = params + '&';
         }
         params = params + `title_keyword=${fields['title']}`;
       }
       if (
         fields['made_public'] !== undefined &&
         (fields['made_public'] === true || fields['made_public'] === false)
       ) {
         if (params !== '?') {
           params = params + '&';
         }
         params = params + `made_public=${fields['made_public']}`;
       }
       if (fields['group']) {
         if (params !== '?') {
           params = params + '&';
         }
         params = params + `group_keyword=${fields['group']}`;
       }
       if (fields['published']) {
         if (params !== '?') {
           params = params + '&';
         }
         params = params + `publish_start=NOW&publish_end=NOW`;
       }
       if (params === '?') {
         params = '';
       }
       this.setState({
         isLoading: true,
         isFitering: true,
         isReseting: false,
       });
       this.props.fetchPosts({
         token: this.props.token,
         params: params,
       });
     }
   }
 
   onReset(e) {
     e.preventDefault();
     this.setState({
       filterData: {
         types: [],
         categories: [],
       },
       isLoading: true,
       isFitering: false,
       isReseting: true,
       errors: {},
     });
     this.myFormRef.reset();
     
     this.props.getPostsSignedUrl({
       token: this.props.token,
       params: '',
     });
   }
 
   /**
    * render() is a react lifecycle method.
    * It uses jsx and returns jsx with backend data.
    */
   render() {
     const { posts, categories } = this.props;
 
     const columns = [
       {
         dataField: 'postUid',
         text: 'PostUid',
       },
       {
         dataField: 'title',
         text: 'Title',
         sort: true,
       },
       {
         dataField: 'type',
         text: 'Type',
         sort: true,
       },
       {
         dataField: 'postcategory_categoryname',
         text: 'Category',
         sort: true,
       },
       {
         dataField: 'group_list',
         text: 'Groups',
         formatter: gropsFormatter,
         headerStyle: (colum, colIndex) => {
           return { width: '200px', textAlign: 'left' };
         },
       },
       {
         dataField: 'publish_start',
         text: 'Publish Start',
         formatter: dateFormatter,
         sort: true,
       },
       {
         dataField: 'publish_end',
         text: 'Publish End',
         formatter: dateFormatter,
         sort: true,
       },
       {
         dataField: 'created_at',
         text: 'Created At',
         formatter: dateFormatter,
         sort: true,
       },
       {
         dataField: 'make_public',
         text: 'Made Public',
         formatter: madePublicFormatter,
         sort: true,
       },
       {
         dataField: 'published',
         text: 'Currently Live',
         formatter: livenowFormatter,
         sort: true,
       },
       {
         dataField: 'button',
         text: 'Actions',
         formatter: this.actionsButtonFormatter,
       },
     ];
 
     const defaultSorted = [
       {
         dataField: 'created_at',
         order: 'desc',
       },
     ];
 
     const postList = posts && (
       <div className="postsTable">
         <BootstrapTable
           bootstrap4
           keyField="postUid"
           wrapperClasses="table-responsive"
           data={posts}
           loading={true}
           columns={columns}
           defaultSorted={defaultSorted}
           pagination={paginationFactory()}
           noDataIndication={indication}
         />
       </div>
     );
 
     return (
       <div>
         <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
           <h1>CREATE NEW</h1>
           <div className="d-flex">
             <NavLink to="/admin/add-newsletter-header">
               <button className="mr-1">Newsletter Header</button>
             </NavLink>
             <NavLink to="/admin/add-newsletter">
               <button className="mr-1">Newsletter Article</button>
             </NavLink>
             <NavLink to="/admin/add-notice">
               <button>Notice , Principal or Dailymail</button>
             </NavLink>
           </div>
         </div>
         <div className="filters mb-2">
           <form ref={(el) => (this.myFormRef = el)}>
             <h2>Filters</h2>
             <div className="brd-1">
               <div className="row">
                 <div className="col-md-6">
                   <div className="date d-flex align-items-center pb-2">
                     <div className="date">
                       <p className="datetext">Live From</p>
                       <DatePicker
                         className="form-control"
                         dateFormat="MMMM d, yyyy"
                         selected={this.state.filterData.publish_start}
                         onChange={(date) =>
                           this.handleDateChange(date, 'publish_start')
                         }
                       />
                       <div className="errorMsg">
                         {this.state.errors['publish_start']}
                       </div>
                     </div>
                   </div>
                 </div>
                 <div className="col-md-6">
                   <div className="date d-flex align-items-center pb-2">
                     <div className="date">
                       <p className="datetext">Live To</p>
                       <DatePicker
                         className="form-control"
                         dateFormat="MMMM d, yyyy"
                         minDate={this.state.filterData.publish_start}
                         selected={this.state.filterData.publish_end}
                         onChange={(date) =>
                           this.handleDateChange(date, 'publish_end')
                         }
                       />
                       <div className="errorMsg">
                         {this.state.errors['publish_end']}
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <div className="brd-1">
               <h3>Types</h3>
               <div className="row">
                 <div className="col-md-3">
                   <label className="typecheck">
                     Newsletter
                     <input
                       type="checkbox"
                       name="newsletter"
                       checked={_.includes(
                         this.state.filterData.types,
                         'newsletter'
                       )}
                       onChange={this.onTypesChange}
                       value="newsletter"
                     />
                     <span className="typemark"></span>
                   </label>
                 </div>
                 <div className="col-md-3">
                   <label className="typecheck">
                     Notices
                     <input
                       type="checkbox"
                       name="notice"
                       checked={_.includes(
                         this.state.filterData.types,
                         'notice'
                       )}
                       onChange={this.onTypesChange}
                       value="notice"
                     />
                     <span className="typemark"></span>
                   </label>
                 </div>
                 <div className="col-md-3">
                   <label className="typecheck">
                     Principal
                     <input
                       type="checkbox"
                       name="principal"
                       checked={_.includes(
                         this.state.filterData.types,
                         'principal'
                       )}
                       onChange={this.onTypesChange}
                       value="principal"
                     />
                     <span className="typemark"></span>
                   </label>
                 </div>
                 <div className="col-md-3">
                   <label className="typecheck">
                     Dailymail
                     <input
                       type="checkbox"
                       name="dailyemail"
                       checked={_.includes(
                         this.state.filterData.types,
                         'dailyemail'
                       )}
                       onChange={this.onTypesChange}
                       value="dailyemail"
                     />
                     <span className="typemark"></span>
                   </label>
                 </div>
               </div>
             </div>
             <div className="brd-1">
               <h3>Categories</h3>
               <div className="row">
                 {categories &&
                   categories.map((item, index) => (
                     <div key={item.postcategoryUid} className="col-md-3">
                       <label className="typecheck">
                         {item.categoryname}
                         <input
                           type="checkbox"
                           onChange={this.onCategoryChange}
                           value={item.categoryname}
checked={this.state.filterData.categories.includes(item.categoryname)}
                         />
                         <span className="typemark"></span>
                       </label>
                     </div>
                   ))}
               </div>
             </div>
             <div className="brd-1">
               <h3>Keywords</h3>
               <div className="row">
                 <div className="col-md-6">
                   <div className="date pb-2">
                     <p className="datetext">Title Keyword</p>
                     <input
                       name="title"
                       type="text"
                       onChange={this.onInputChange}
                       value={this.state.filterData.title || ''}
                       className="form-control"
                     />
                   </div>
                 </div>
                 <div className="col-md-6">
                   <div className="date pb-2">
                     <p className="datetext">Group Keyword</p>
                     <input
                       name="group"
                       type="text"
                       onChange={this.onInputChange}
                       value={this.state.filterData.group || ''}
                       className="form-control"
                     />
                   </div>
                 </div>
               </div>
             </div>
             <div className="d-flex justify-content-between pt-1 flex-column flex-lg-row">
               <label className="typecheck">
                 Currently Live
                 <input
                   name="published"
                   type="checkbox"
                   onChange={this.onLiveNowChange}
                 />
                 <span className="typemark"></span>
               </label>
               <label className="typecheck">
                 Made Public
                 <input
                   name="made_public"
                   type="checkbox"
                   onChange={this.onMadePublicChange}
                 />
                 <span className="typemark"></span>
               </label>
               <div className="">
                 {this.state.isReseting && this.state.isLoading && (
                   <button
                     disabled={this.state.isLoading}
                     onClick={this.onReset}
                     className="btn-secondary filter-btn"
                   >
                     Reset ...
                   </button>
                 )}
                 {!this.state.isReseting && (
                   <button
                     onClick={this.onReset}
                     className="btn-secondary filter-btn"
                   >
                     Reset
                   </button>
                 )}
                 {this.state.isLoading && this.state.isFitering && (
                   <button
                     disabled={this.state.isLoading}
                     onClick={this.onFilter}
                     className="btn-secondary filter-btn"
                   >
                     Filter ...
                   </button>
                 )}
                 {!this.state.isFitering && (
                   <button
                     onClick={this.onFilter}
                     className="btn-secondary filter-btn"
                   >
                     Filter
                   </button>
                 )}
               </div>
             </div>
           </form>
         </div>
         {this.props.postActionLoading === true && (
           <div className="sweet-loading">
             <GridLoader
               css={override}
               sizeUnit={'px'}
               size={40}
               color={'#cadb2a'}
               loading={this.props.postActionLoading}
             />
           </div>
         )}
         {postList}
 
         <DialogBox
           show_modal={this.state.modal_data}
           hide_modal={this.handleCloseModal.bind(this)}
           onSubmit={this.OnDialogSubmit.bind(this)}
         />
 
         <div className="overlay"></div>
       </div>
     );
   }
 }
 
 /**
  * It is called every time the store state changes.
  * It receives the entire store state, and should return an object of data this component needs.
  * @param {*} state : Getting updated state object from reducer
  * @param {*} props : Getting props of this component
  */
 function mapStateToProps(state) {
   return {
     postActionLoading: state.posts.actionsloading,
     token: state.user.cognito_data.token,
     user: state.user.user,
     signed_url: state.posts.signed_url,
     posts: Object.values(state.posts.byId),
     categories: Object.values(state.category.byId),
   };
 }
 
 function dateFormatter(cell, row) {
   if (cell === 'UNPUBLISHED' || cell === 'INDEFINITE') {
     return cell;
   } else {
     return moment(cell).format('YYYY-MM-DD hh:mm a');
   }
 }
 
 function gropsFormatter(cell, row) {
   if (cell && cell.groups && cell.groups.length > 0) {
     let str = '';
     cell.groups.forEach((item, index) => {
       str = str + item.groupname;
       if (index !== cell.groups.length - 1) {
         str = str + ' ,';
       }
     });
     if (cell.userTypes && cell.userTypes.length > 0) {
       // get selected contact types from list
       let contactTypes = utilPostService.getContactTypes(cell.userTypes);
       if (contactTypes) {
         str = str + contactTypes;
       }
     }
     return str;
   } else {
     return '';
   }
 }
 
 function livenowFormatter(cell, row) {
   if (cell) {
     if (
       new Date(row.publish_start) <= new Date() &&
       new Date(row.publish_end) >= new Date()
     ) {
       return 'Yes';
     } else {
       return 'No';
     }
   } else {
     return 'No';
   }
 }
 
 function madePublicFormatter(cell, row) {
   if (cell !== undefined) {
     if (cell) {
       return 'Yes';
     } else {
       return 'No';
     }
   } else {
     return '';
   }
 }
 
 function indication() {
   return 'No records found!';
 }
 
 /**
  * connect() function connects a react component to a redux store.
  */
 export default connect(mapStateToProps, (dispatch) =>
   bindActionCreators(postsActions, dispatch)
 )(Posts);
 